export default function parseCheckData(rawData) {
  if (!rawData) return {};

  return {
    followers: rawData.followers ?? null,
    posts: rawData.posts ?? null,
    reach: Array.isArray(rawData.postArray)
      ? rawData.postArray.reduce((sum, post) => sum + (Number(post?.reach) || 0), 0)
      : null,
    quality_score: rawData.user_typeScore ?? null,
    language: rawData.language ?? null,
    country: rawData.country ?? null,
    city: rawData.city ?? null,
    website: rawData.website ?? null,
    gender: rawData.gender ?? null,
    bio: rawData.description ?? null,
    profile_pic_url: rawData.profilePicUrl ?? null,
  };
}